import {Button, Dialog, DialogActions, DialogContent, Grid, Toolbar, Typography, useTheme} from "@mui/material";
import {ProductColumn} from "./catalog_columns";
import ProductApproveDialog from "../../../components/Dialogs/ProductApproveDialog";
import React, {useEffect} from "react";
import CheckIcon from "@mui/icons-material/Check";

interface BulkApprovalActionsTableProps {
    open: boolean;
    setOpen: (open: boolean) => void;
    setUpdating: (updating: boolean) => void;
    setError: (error: any) => void;
    manualApproveProducts: any[];
    onFinish: () => void;
    onClose?: () => void;
    currentCatalog: string;
    isRetailer: boolean;
    approveAndList: boolean;
    forceUniqueRetailerSku?: boolean;
}

export default function BulkApprovalActionsTable(props: BulkApprovalActionsTableProps) {
    const {open, setOpen, currentCatalog} = props;
    const {setUpdating, setError} = props;
    const {manualApproveProducts, onFinish, approveAndList} = props;

    const theme = useTheme();
    const [products, setProducts] = React.useState<any[]>(manualApproveProducts);
    const [singleOpen, setSingleOpen] = React.useState<boolean>(false);
    const [singleData, setSingleData] = React.useState<any>(null);

    useEffect(() => {
        setProducts(manualApproveProducts);
    }, [manualApproveProducts, open]);

    const onClose = () => {
        if(props.onClose) props.onClose();
        setOpen(false);
    }

    return (
        <>
            <Dialog open={open} onClose={() => onClose()} maxWidth={"sm"} fullWidth={true}>
                <div style={{
                    height: "10px",
                    width: "100%",
                    background: theme.palette.error.main,
                    transition: "background 0.5s ease"
                }}/>

                <Grid container style={{flexDirection: "column"}}>
                    <Toolbar className='lbtoolbar'>
                        Manual review required
                    </Toolbar>
                    <Typography style={{padding: "0 24px"}}>
                        The following products require manual review.
                    </Typography>
                </Grid>
                <DialogContent>
                    <Grid container style={{overflow: "auto", maxHeight: "300px", width: "100%"}}>
                        {products.map((product, index) => {
                            return (
                                <Grid item container key={index} style={{gap: "8px", padding: "8px 0", width: "100%"}}>
                                    <Grid container item direction="column" style={{paddingBottom: "5px", borderBottom: "solid gray 1px", width: "100%"}}>
                                        <Grid container item justifyContent={"space-between"} alignItems={"center"} wrap={"nowrap"}>
                                            <ProductColumn style={{paddingBottom: "10px", flex: 1, minWidth: 0}}
                                                           row={{
                                                               parentSku: product.parentSku,
                                                               sku: product.sku,
                                                               image: product.image,
                                                               name: product.name,
                                                           }}
                                                           column={{id: 0}}
                                                           noFilter={true}
                                            />

                                            <Button
                                                variant={"outlined"}
                                                disabled={product.actionCompleted}
                                                onClick={() => {
                                                    setSingleData(product);
                                                    setSingleOpen(true);
                                                }}
                                            >
                                                {product.actionCompleted ? (
                                                    <CheckIcon />
                                                ) : (
                                                    "Approve"
                                                )}
                                            </Button>
                                        </Grid>
                                        
                                        {product.conflictInfo && (
                                            <Grid item style={{padding: "8px 0", backgroundColor: "#fff3cd", borderRadius: "4px", marginTop: "8px"}}>
                                                <Typography variant="body2" style={{color: "#856404", padding: "8px"}}>
                                                    <strong>Conflict detected:</strong> {product.conflictInfo.message}
                                                </Typography>
                                            </Grid>
                                        )}
                                    </Grid>
                                </Grid>
                            );
                        })}
                    </Grid>
                </DialogContent>

                <DialogActions>
                    <Button variant={"outlined"} onClick={() => onClose()} color="primary">
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
            {singleOpen && (
                <ProductApproveDialog
                    approveAndList={approveAndList}
                    isRetailer={props.isRetailer}
                    forceUniqueRetailerSku={props.forceUniqueRetailerSku}
                    setUpdating={setUpdating} setError={setError}
                    open={singleOpen} setOpen={setSingleOpen}
                    product={singleData} currentCatalog={currentCatalog}
                    onApprove={() => {
                        const newProducts = products.map(p => {
                            if (p.id === singleData.id) {
                                p.actionCompleted = true;
                            }
                            return p;
                        });

                        if(newProducts.every(p => p.actionCompleted)) {
                            onFinish();
                            setOpen(false);
                        }
                        else {
                            setProducts(newProducts);
                        }
                    }}
                />
            )}
        </>
    );
}
